import { SelectOption } from "@models/ui-models/select-options";
import { getPositionTypesOptions } from "../../company-change-officer-appoint/company-change-officer-appoint.component";
import { RelationshipType } from "@models/relationships/relationship-type.enum";

export function getCompanyRegistrationOfficersPositionTypesOptions(shouldAddShareholder = false, shouldAddPublicOfficer = false): SelectOption[] {
  const positions = getPositionTypesOptions()
    .filter((relationshipTypeOption) => relationshipTypeOption.value != RelationshipType.AlternativeDirector);

  if (shouldAddShareholder) {
    positions.push({
      label: 'Shareholder',
      value: RelationshipType.Securityholder,
    });
  }

  if (shouldAddPublicOfficer) {
    positions.unshift({
      label: 'Public Officer',
      value: RelationshipType.PublicOfficer,
      disabled: true
    });
  }

  return positions;
}
